import store from "@/store";
import BaseAPI from "../baseApi";
import LoginError from "../models/loginError";
import LoginResponse from "../models/loginResponse";

export default class UserService extends BaseAPI {
  constructor(vue: Vue) {
    super(vue);
  }

  protected baseUrl(): string {
    return super.baseUrl() + "/user";
  }

  public async login(
    login: string,
    password: string
  ): Promise<LoginResponse | LoginError> {
    let responce = await this.request(this.baseUrl() + "/login", {
      method: "POST",
      body: JSON.stringify({
        username: login,
        password: password
      })
    });
    let result = JSON.parse(responce.content);
    if (responce.code == 401) {
      return {
        loginError: true
      };
    }
    if (responce.code == 200) {
      let expire = new Date();
      expire.setSeconds(expire.getSeconds() + result.data.expires);
      this.cookies.set("token", result.data.token, expire);
      store.dispatch("setLoggedIn", true);
      this.router.push("/");
    }
    return result;
  }
}
